export default __webpack_public_path__ + "static/media/desktop.7afb29b8.jpg";